<script>
import tableHandle from '@/mixin/tableHandle'
import {removeToken} from "@/utils/auth";
import ContractsTemplate from "@/views/new/order/components/ContractsTemplate.vue";

export default {
  components: {ContractsTemplate},
  mixins: [tableHandle],
  name: "NavBar",
  methods:{
    getList(){

    },
    loginOut() {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken()
        this.$message.success('退出成功')
        setTimeout(() => {
          this.$router.push({ name: 'wxLogin' })
        }, 1000)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        });
      });
    },
    editLanguage(){
      this.$i18n.locale=='zh'?this.$i18n.locale='en':this.$i18n.locale='zh'   //设置中英文模式
      localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
    },
  }
}
</script>

<template>
  <div style="width: 100%;">
    <div class="top-header">
      <div class="navbar navbar-expand-lg">
        <div class="container1">
          <ul class="col-1" @click="linkTo('new-index')">
            <li class="l1">
              <img src="../../static/index/logo.png" class="logo"  />
            </li>
            <li>
              <img src="../../static/index/logo1.png" class="logo1" />
              <img src="../../static/index/logo2.png" class="logo2" />
              <img src="../../static/index/logo3.png" class="logo3" />
            </li>
          </ul>
          <div class="navbar-collapse">
            <ul class="navbar-nav mx-auto">
              <!-- 首页 -->
              <li class="nav-item" @click="linkTo('new-index')">
                <svg class="nav-icon" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                </svg>
                <a class="nav-link">首页</a>
              </li>

              <!-- 订单信息 -->
              <li class="nav-item" @click="linkTo('user-orders')">
                <svg class="nav-icon" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                </svg>
                <a class="nav-link">订单账户</a>
              </li>

              <!-- 个人信息 -->
              <li class="nav-item" @click="linkTo('mine-entrust')">
                <svg class="nav-icon" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
                <a class="nav-link">个人账户</a>
              </li>
              <!-- 切换新版 -->
              <li class="nav-item" @click="linkTo('new-index2')">
                <img class="nav-icon"  width="20px" src="../../static/svg/发布新版本.svg"/>
                <a class="nav-link">切换新版</a>
              </li>
              <!-- 退出 -->
              <li class="nav-item" @click="loginOut">
                <svg class="nav-icon" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                </svg>
                <a class="nav-link">退出登录</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.top-header{
  border-bottom: 6px solid transparent;

  border-image-source: url('../assets/new/icon/gray_Vborder.png');
  border-image-slice:    6 0 6 0;
  border-image-repeat:   repeat;
}
.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: .5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: .3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: .5rem;
  --bs-navbar-toggler-padding-y: .25rem;
  --bs-navbar-toggler-padding-x: .75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: .375rem;
  --bs-navbar-toggler-focus-width: .25rem;
  --bs-navbar-toggler-transition: box-shadow .15s ease-in-out;
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  background: #fff;
  z-index: 99;
  height: 100px;
  border: 0;
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
  box-shadow: 0px 0px 5px #c3c3c3c7;
}
.container1 {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  padding-right: calc(var(--bs-gutter-x)* .5);
  padding-left: calc(var(--bs-gutter-x)* .5);
  margin-right: auto;
  margin-left: auto;
  display: flex;
  gap:120px;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
  //max-width: 1600px;
}

.col-1{
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  list-style: none;
  li{
    display: flex;
    gap: 20px;
    align-items: center;
  }
}

.l1{
  margin-right: 40px;
}

.navbar-collapse {
  //width: 45%;
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
  display: flex;
}

.navbar-expand-lg .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: .5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  flex-direction: row;
  li {
    display: list-item;
    text-align: -webkit-match-parent;
    unicode-bidi: isolate;
  }
}

.mx-auto {
  margin-right:auto !important ;
  margin-left: auto !important;
}
.navbar .navbar-nav .nav-link {
  font-family: var(--primary-font);
  font-weight: 400;
  color: #1296DB;
  margin: 1px;
  -webkit-transition: all .4s;
  transition: all .4s;
  padding-right: 5px;
  padding-left: 5px;
  &:hover {
    cursor: pointer;

  }
}
.nav-item{
  display: flex !important;
  font-size: 18px;
  align-items: center;
  margin: 0px 20px;
}

.nav-img{
  width: 25px;
}

.logo {
  width: 240px;
  height: 70px;
  object-fit: contain;
}
.logo1 {
  width: 70px;
  height: 70px;
}
.logo2 {
  width: 70px;
  height: 70px;
}
.logo3 {
  width: 70px;
  height: 70px;
}
/* 导航整体样式 */
.navbar-collapse {
  padding: 12px 0;
}

.navbar-nav {
  display: flex;
  justify-content: space-around;
  max-width: 640px;
  margin: 0 auto;
}

/* 导航项样式 */
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

/* 图标样式 */
.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 6px;
  color: #3498db; /* 默认图标颜色 */
  transition: all 0.3s ease;
}

/* 文字链接样式 */
.nav-link {
  font-size: 14px;
  font-weight: 500;
  color: #333; /* 深灰色文字 */
  text-decoration: none;
  transition: all 0.3s ease;
}

/* 悬停效果 */
.nav-item:hover {
  background: #f8f9fa;
}
.nav-item:hover .nav-icon {
  color: #1e88e5; /* 悬停图标色 */
}
.nav-item:hover .nav-link {
  color: #2980b9; /* 悬停文字色 */
}

/* 激活状态 */
.nav-item.active {
  background: #e3f2fd;
}
.nav-item.active .nav-icon {
  color: #0d47a1; /* 激活图标色 */
}
.nav-item.active .nav-link {
  color: #1a5276; /* 激活文字色 */
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/layouts/NavBar.vue